import axios from 'axios';
import {delete_session, get_session, set_session, unescapeHTML} from "../helpers";

export default {
  template: "#vue-account",
  delimiters: ["${", "}"],
  props: {
    customer_id: String, // "integer"
    first_name_: String,
    last_name_: String,
    email_: String,
    addresses_: String
  },
  data: function () {
    return {
      editing: null,
      errors: {name: false, address: false},
      pending: false,

      first_name: null,
      last_name: null,
      email: null,
      addresses: null,
      address: {
        country: 'Canada'
      },
      address_index: null,

      subscribed: null,
      mailchimp_params: null
    };
  },
  computed: {
    subscribe_action_link() {
      if (this.subscribed) {
        return `https://sourceforsports.us12.list-manage.com/profile?u=${this.mailchimp_params.u}&id=${this.mailchimp_params.id}&e=${this.mailchimp_params.e}`
      }
    }
  },
  methods: {
    deleteAddress(val) {
      this.address.delete = true
      this.saveEdit(val)
    },
    cancelEdit(typ) {
      if (typ === "name") {
        let init = get_session('init_customer')
        if (init) {
          try {
            init = JSON.parse(init);
            this.first_name = init.first_name;
            this.last_name = init.last_name;
            this.email = init.email;
          } catch (e) {
            delete_session('init_customer');
          }
        }
      } else if (typ === "address") {
        const init = get_session('init_addresses')
        if (init) {
          try {
            this.addresses = JSON.parse(init);
          } catch (e) {
            delete_session('init_addresses');
          }
        }
      }
      this.toggleEdit(null);
    },
    toggleEdit(typ, e, address, index) {
      this.editing = typ;
      if (typ === 'address') {
        if (address) {
          this.address = address;
          this.address_index = index;
        } else {
          this.address = {
            country: this.$store.state.country === "US" ? "USA" : 'Canada'
          };
          this.address_index = null;
        }
      }
    },
    saveEdit(typ, e) {
      this.pending = true;
      let data = {
        "name": () => {
          return {
            "type": "name",
            "first_name": this.first_name,
            "last_name": this.last_name,
            "email": this.email
          }
        },
        "address": () => {
          return {
            "type": "address",
            "addresses": [this.address]
          }
        }
      }
      axios.put('/apps/api/customer/' + this.customer_id, data[typ]())
      .then(resp => {
        this.pending = false;
        let updatedData = resp.data.customer;
        if (typ === "name") {
          this.first_name = updatedData.firstName;
          this.last_name = updatedData.lastName;
          this.email = updatedData.email;
          set_session('init_customer', JSON.stringify(
              {first_name: this.first_name, last_name: this.last_name, email: this.email}
          ));
        } else if (typ === "address" && updatedData.addresses) {
          this.addresses = updatedData.addresses
          set_session('init_addresses', JSON.stringify(updatedData.addresses));
          this.address = {};
          this.address_index = null;
        }
        this.toggleEdit(null);
      }, err => {
        this.pending = false;
        if (err.response.data && err.response.data.error) {
          this.errors[typ] = err.response.data.error;
        } else {
          this.errors[typ] = true;
        }
      })
    },
    formSubmit: function (typ, e) {
      if (e === undefined) {
        e = typ
        typ = 'locale'
      }
      e.preventDefault();
      this.saveEdit(typ, e)
    },
    redirectAccountPage(to) {
      if (to === 'account') {
        window.location.href = `${window.location.origin}${this.$store.getters.locale_uri_prefix}/account`;
      } else if (to === 'orders') {
        window.location.href = `${window.location.origin}${this.$store.getters.locale_uri_prefix}/account?view=orders`;
      }
    }
  },
  mounted() {
    this.first_name = unescapeHTML(this.first_name_) || ""
    this.last_name = unescapeHTML(this.last_name_) || ""
    this.email = unescapeHTML(this.email_) || ""
    set_session('init_customer',
        JSON.stringify({first_name: this.first_name, last_name: this.last_name, email: this.email})
    );
    const addresses = unescapeHTML(this.addresses_)
    this.addresses = JSON.parse(addresses) || []
    set_session('init_addresses', addresses);

    if (this.$store.state.country === 'US') {
      this.address.country = "USA"
    }

    axios.get("/apps/api/communications",
        {params: {customer_id: this.customer_id, email: this.email}}).then(
        resp => {
          this.subscribed = resp.data.subscribed || resp.data.exists
          this.mailchimp_params = {u: resp.data.u, id: resp.data.id, e: resp.data.e}
        },
        err => {
          console.error(`Error loading customer subscription status - ${this.customer_id}`)
          this.subscribed = false
        }
    )
  }
}